module.exports = __webpack_public_path__ + "media/images/map-icons/start_icon@2x-2c2ae5b935845f566e6b252b3767bff0.png";